// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36MAW","selected":"styles_selected__3Fh9a"};